var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7",
  "data-name": "Ellipse 7",
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#1370fc"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Polygon_9",
  "data-name": "Polygon 9",
  d: "M8,0l8,16H0Z",
  transform: "translate(30 12) rotate(90)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/video-play.a793340e.svg";
export { SvgComponent as ReactComponent };